import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues, change } from 'redux-form';
import { withRouter } from 'react-router';
import v from 'validate.js';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { numberWithCommas, parseNumberWithCommas } from '../../../../../helpers';
import { onSubmit } from '../../../../../common/components/submit-button';
import RenderInput from '../../../../../common/components/render-input';
import { trackingEvent } from '../../../../../helpers/tracking';

const tracking = {
    eventAction: 'Prosperity Planner - Step 8',
    eventLabel: 'Asses My Finances - What I Spend'
};

export const formName = Routes.STEPEIGHT;

export const formDetails = {
    key: 'expenses',
    title: 'What I spend',
    formName,
    totalKey: 'currentExpenses',
    fields: {
        savings: {
            label: 'Saving'
        },
        retirement: {
            label: 'RRSP/RESP Contr.',
        },
        living: {
            label: 'Mortgage/Rent/Taxes'
        },
        homeMaintenance: {
            label: 'Home Maintenance'
        },
        food: {
            label: 'Food'
        },
        utilities: {
            label: 'Utilities'
        },
        connectedServices: {
            label: 'Phone/Internet/Cable'
        },
        insurance: {
            label: 'Insurance (home, auto, life)'
        },
        childcare: {
            label: 'Childcare'
        },
        education: {
            label: 'Education'
        },
        clothing: {
            label: 'Clothing'
        },
        fun: {
            label: 'Fun'
        },
        vehicle: {
            label: 'Car/Gas/Parking'
        },
        goodwill: {
            label: 'Charitable Giving'
        },
        loans: {
            label: 'Loans/Lines of Credit'
        },
        creditCard: {
            label: 'Credit Card'
        }
    }
};

const minValue = 0;

const validate = values => v(values,
    Object.keys(formDetails.fields).reduce((obj, val) => ({
        ...obj,
        [val]: {
            numericality: {
                greaterThanOrEqualTo: minValue,
                notGreaterThanOrEqualTo: `must be greater than or equal to $${numberWithCommas(minValue)}`
            }
        }
    }), {})
);

class StepEightForm extends Component {
    calculateTotal() {
        const {
            props: {
                formValues: {
                    [formDetails.totalKey]: removedTotal,
                    ...values
                }
            }
        } = this;

        return Object.values(values).reduce((total, val) => total + val, 0);
    }

    componentDidUpdate() {
        const {
            props: {
                changeFieldValue
            }
        } = this;

        changeFieldValue(formDetails.totalKey, this.calculateTotal());
    }

    render() {
        const {
            formValues : {
                [formDetails.totalKey]: total
            } = {}
        } = this.props;
        return (
            <form className={styles.form}>
                {
                    Object.keys(formDetails.fields).map(key =>
                        <Field
                            key={key}
                            type='text'
                            name={key}
                            label={formDetails.fields[key].label}
                            tooltip={formDetails.fields[key].tooltip}
                            prefix='$'
                            format={numberWithCommas}
                            parse={parseNumberWithCommas}
                            component={RenderInput}
                        />
                    )
                }
                <Field
                    type='text'
                    name='total'
                    label='Total'
                    prefix='$'
                    readOnlyValue={numberWithCommas(total)}
                    format={numberWithCommas}
                    parse={parseNumberWithCommas}
                    component={RenderInput}
                />
            </form>
        );
    }
}

const formValues = getFormValues(formDetails.formName);

const mapStateToProps = (state) => ({
    formValues: formValues(state),
    paginationSkipState: state.calculator.paginationHasSkip,
});

const mapDispatchToProps = (dispatch) => ({
    changeFieldValue: (field, value) => dispatch(change(formDetails.formName, field, value))
});

StepEightForm = reduxForm({
    form: formDetails.formName,
    destroyOnUnmount: false,
    validate,
    onSubmit,
    initialValues: Object.keys(formDetails.fields).reduce((obj, val) => ({
        ...obj,
        [val]: minValue
    }), {}),
    skipPath: `/prosperity-planner${Routes.SUMMARY}`,
    redirectPath: `/prosperity-planner${Routes.STEPNINE}`,
    tracking: () => trackingEvent(tracking)
}, mapStateToProps, mapDispatchToProps)(StepEightForm);

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(StepEightForm));
